import React from 'react';

import { useMenuContext } from '../../ContextState/useMenuContext';
import { DATA_TEST } from '../../enums';
import { BackNavigation } from '../Components/BackNavigation';
import { MobileErrorView } from '../Components/MobileErrorView';
import { MobileLoadingMenu } from '../Components/MobileLoadingMenu';

import { MobileLevelThreeMenuSection } from './MobileLevelThreeMenuSection';
interface IMobileLevelThreeMenuProps {
  closeMenu(): void;
}
export const MobileLevelThreeMenu: React.FC<IMobileLevelThreeMenuProps> = ({ closeMenu }) => {
  const {
    currentLevelOneItem,
    fetchLevelThreeSubmenuSections,
    selectedLevelTwoId,
    setSubmenuLoadingItemId,
    submenuLoadingItemId,
    setSelectedLevelTwoId,
    setLevelThreeLoadingError,
    levelThreeLoadingError
  } = useMenuContext();

  const levelTwoParentItem = currentLevelOneItem?.submenuSections
    ?.flatMap((section) => section.items)
    .find((item) => item?.id === selectedLevelTwoId);

  const levelThreeSubmenuSections = levelTwoParentItem?.submenuSections;

  React.useEffect(() => {
    if (levelTwoParentItem?.shouldFetchNestedMenuItems && !levelThreeSubmenuSections?.length) {
      setSubmenuLoadingItemId(levelTwoParentItem.id);
      const fetchSubmenuSections = async () => {
        await fetchLevelThreeSubmenuSections(levelTwoParentItem)
          .catch(() => {
            setLevelThreeLoadingError(true);
          })
          .finally(() => {
            setSubmenuLoadingItemId(undefined);
          });
      };
      void fetchSubmenuSections();
    }
  }, [currentLevelOneItem, levelTwoParentItem]);

  const renderLoading = () => {
    if (submenuLoadingItemId && !levelThreeLoadingError) {
      return <MobileLoadingMenu dataTest={DATA_TEST.mobile_level_three_loading_menu} />;
    }
  };

  const renderError = () => {
    if (levelThreeLoadingError) {
      return <MobileErrorView dataTest={DATA_TEST.mobile_level_three_error_view} />;
    }
  };

  const renderMenuSections = () => {
    if (!submenuLoadingItemId && !levelThreeLoadingError && (levelTwoParentItem?.submenuSections?.length ?? 0) > 0) {
      return levelThreeSubmenuSections?.map((section) => (
        <MobileLevelThreeMenuSection section={section} key={section.title} closeMenu={closeMenu} />
      ));
    }
  };

  return (
    <>
      <BackNavigation
        onClick={() => {
          setSelectedLevelTwoId(null);
        }}
        title={levelTwoParentItem?.label}
      />
      {renderError()}
      {renderLoading()}
      {renderMenuSections()}
    </>
  );
};
